import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WorkOrders_ds_get_accessorial_operationcode_by_operationcodeId_projectIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { projectId: number, operationCodeId: number }): 
  Promise<{ result: { BillingContractLineId?: number, StrategyFieldName?: string, Value?: string, BillingContractLine?: { ResultingUomId?: number, ResultingUom?: { Short_name?: string } } } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil($inParams.operationCodeId)) {
      $missingRequiredInParams.push('\'operationCodeId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      projectId: number, operationCodeId: number    }) {
        if(isNil($inParams.projectId)) {
          return true; 
        }
        if(isNil($inParams.operationCodeId)) {
          return true; 
        }
      return false;
    }
}
